import { Breadcrumb, Card, EventHandler, Search, SofturaTable } from "client/CommonComponents"
import excel from '../../../assets/images/Excel.svg'
import CreateNewRequestIcon from '../../../assets/images/New Asset Request.svg'
import permissions, { isAuthorized } from "client/utils/Permissions";

const AcquisitionCodeMaintenance = (props: any) => {

  const {
    acquisitionCodeMaintenanceColumns,
    gridData,
    setFilters,
    serverTotal,
    fetchAction,
    pagesCount,
    onSearchOrder,
    searchValue,
    onExportExcel,
    breadcrumlist,
    createNewAcquisitionOnClick,
    showGrid
  } = props;

  return (
    <div className='CustomerMyOrder'>
      <div className='breadcrumb-toolbar mb-1'>
        
              <button className='create-new-order-btn mb-3 mb-md-0 me-2' title={'Add New Acquisition Code'} disabled={!(isAuthorized(permissions.ViewAdmin) || isAuthorized(permissions.Create_Edit_Admin))} data-attribute="AcquisitionCodeMaintenance_Add_New_Acquisition_Code_Button">
          <EventHandler onEvent={createNewAcquisitionOnClick} data-attribute="AcquisitionCodeMaintenance_Default_EventHandler">
                      <a><img src={CreateNewRequestIcon} alt='btn-icon' /><span>{'Add New Acquisition Code'}</span></a>
          </EventHandler>
          </button>
      
        <div className='order-1'><Breadcrumb items={breadcrumlist} maxDisplayedItems='5'  data-attribute="AcquisitionCodeMaintenance_Default_Breadcrumb" /></div>
      </div>
      <Card data-attribute="AcquisitionCodeMaintenance_Default_Card">
        <div className='create-new-order-container'>
          <div className='grid-block pt-2'>
            <div className='mb-1 top-section'>
              <p className='mt-1'>ACQUISITION CODE MAINTENENCE</p>
              <div className='clearfix mt-2 mb-3'>
                <div className='pull-left searchblock'>
                  <Search
                    placeholder='Search By Acquisition Code'
                    className='searchTextbox'
                    onSearch={(e?: any) => onSearchOrder(e, true)}
                    onBlur={(e?: any) => onSearchOrder(e, false)}
                    onChange={(e?: any) => onSearchOrder(e, false)}
                    value={searchValue}
                   data-attribute="AcquisitionCodeMaintenance_Default_Searchbox" />
                </div>
                <div className='pull-right datepickerControl mb-2 mb-sm-0 mt-sm-0 mt-2'>
                  <div className='excel-section admin_excel'>
                    <EventHandler onEvent={(e: any) => onExportExcel(e)} data-attribute="AcquisitionCodeMaintenance_Default_EventHandler_2">
                      <img src={excel} alt='excel' />
                    </EventHandler>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`order-listing-grid pe-0 ${gridData?.length != 0
                ? "softura-table filterTable admin"
                : "softura-table filterTable paginationNav"
                }`}
            >
              {showGrid &&
                <SofturaTable
                  data={gridData ?? []}
                  columns={acquisitionCodeMaintenanceColumns}
                  sort={true}
                  getFilterValue={setFilters}
                  defaultPageSize={10}
                  pageSizes={[10, 20, 50]}
                  globalSearch={false}
                  filter={true}
                  defaultPaginationPosition='Both'
                  fixedHeader={true}
                  serverTotal={serverTotal}
                  fetchAction={fetchAction}
                  isServerSide={true}
                  pagesCount={pagesCount}
                 data-attribute="AcquisitionCodeMaintenance_Default_Grid" />
              }
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default AcquisitionCodeMaintenance